import React from "react";
import Moment from "react-moment";
import { ConvertJson2Date } from "./Helper";

export function ThaiDate({ dateValue }) {
  let numYear = <Moment format="DD-MM-" locale="th" date={dateValue} />;
  let thYear = dateValue.substring(0, 4);
  return (
    <div>
      {numYear}
      {parseInt(thYear) + 543}
    </div>
  );
}

export function GetTime({ dateValue }) {
  let numYear = <Moment format="HH:mm" locale="th" date={dateValue} />;
  return numYear;
}

export function GetThaiDateTime({ dateValue }) {
  if (!dateValue) return null;
  let numYear = <Moment format="DD-MM-" locale="th" date={dateValue} />;
  let thYear = dateValue.substring(0, 4);
  let txTime = <Moment format="HH:mm" locale="th" date={dateValue} />;

  return (
    <div>
      {numYear}
      {parseInt(thYear) + 543} {txTime}
    </div>
  );
}

export function GetThaiDateTime2(props) {
  const { dateValue } = props;
  if (!dateValue) return null;
  let numYear = <Moment format="DD-MM-" locale="th" date={dateValue} />;
  let thYear = dateValue.substring(0, 4);
  let txTime = <Moment format="HH:mm" locale="th" date={dateValue} />;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
      {...props}
    >
      <div>
        {numYear}
        {parseInt(thYear) + 543}
      </div>
      <div>{txTime}</div>
    </div>
  );
}

export function GetThaiDateTimeCheckToday({ dateValue }) {
  if (!dateValue) return null;
  let numYear = <Moment format="DD-MM-" locale="th" date={dateValue} />;
  let thYear = dateValue.substring(0, 4);
  let txTime = <Moment format="HH:mm" locale="th" date={dateValue} />;

  // let isToday = ConvertJson2Date(dateValue) === ConvertJson2Date(new Date());
  return (
    <div>
      {ConvertJson2Date(dateValue) !== ConvertJson2Date(new Date()) ? (
        <div style={{ paddingBlock: "0px", paddingInline: "0px" }}>
          {numYear}
          {parseInt(thYear) + 543}{" "}
        </div>
      ) : (
        <>วันนี้ </>
      )}
      <div>{txTime}</div>
    </div>
  );
}

export function EngDateFormat(dateValue) {
  try {
    let tmp = dateValue.toLocaleDateString("en-EN"); // m/d/y
    let m = tmp.split("/");
    m[0] = "0" + m[0];
    m[1] = "0" + m[1];
    return (
      m[2] +
      "-" +
      m[0].substr(m[0].length - 2) +
      "-" +
      m[1].substr(m[1].length - 2)
    );
  } catch (error) {
    return new Date();
  }
}

export function EngDateFormatNoSplit(dateValue) {
  try {
    let tmp = dateValue.toLocaleDateString("en-EN"); // m/d/y
    let m = tmp.split("/");
    m[0] = "0" + m[0];
    m[1] = "0" + m[1];
    return m[2] + m[0].substr(m[0].length - 2) + m[1].substr(m[1].length - 2);
  } catch (error) {
    return new Date();
  }
}

export const ConvertDateFromSQL = (srcTDate) => {
  return new Date(srcTDate).toLocaleDateString("th-TH", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });

  // return new Date(srcTDate).toLocaleDateString("th-TH", {
  //   year: "numeric",
  //   month: "short",
  //   day: "numeric",
  //   hour12: false,
  //   hour: "2-digit",
  //   minute: "2-digit",
  // });
};

export const DateAddMinutes = (srcDate, minutes) => {
  let cur = new Date(srcDate);
  cur.setMinutes(cur.getMinutes() + minutes);
  return cur.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour12: false,
    hour: "2-digit",
    minute: "2-digit",
  });
};
